import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textEllipsis'
})
export class TextEllipsisPipe implements PipeTransform {

  transform(value: any, args?: any, maxChar?: number): any {
    if (value && typeof document !== 'undefined') {
      if (args) {
        const updateText = document.createElement('div');
        updateText.innerHTML = value || '';
        return updateText.textContent.replace(/\s\s+/g, ' ').substr(0, maxChar || 500).concat('...');
      } else {
        return value;
      }
    }
  }

}
